import React, { useContext } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { routes } from '../routes';
import {
  HugeTitle,
  FlexBox,
  InvertedParagraph,
  InvertedH2,
  ClickableBox,
  Paragraph,
  SpacingBox,
  Container,
  TextOnlyUnderlinedButton,
} from '../Components';
import { getTranslateByScope } from '../i18n';
import styles from './LandingPage.module.scss';
import AppContext from '../AppContext';
import { genres } from '../constants';
import { getTischOffensivesForCurrentUser } from '../selectors';
import { navigateToProductListWithGenre } from '../utils/navigations';
import SchLogoImg from "../assets/Logo.png";

const translate = getTranslateByScope('app.landingPage');
const translateCreateNewOrder = getTranslateByScope('app.orderList');

const Dimmer = () => <div className={styles.dimmer} />;

const Logo = () => (
  <img
    alt="logo"
    style={{ zIndex: 100000000 }}
    width="200px"
    src={SchLogoImg}
  />
);

const CollectionCard = ({ image, title, onClick }) => (
  <ClickableBox onClick={onClick} className={styles.outsideCard}>
    <div
      className={styles.collectionCard}
      style={{
        position: 'absolute',
        backgroundImage: `url(${image})`,
      }}
    />
    <Dimmer />

    <FlexBox
      paddingBottom="lg"
      marginLeft="md"
      style={{ height: '100%' }}
      justifyContent="flex-end"
      flex={1}
      flexDirection="column">
      <div style={{ zIndex: 2 }}>
        <InvertedParagraph>{translate('collection')}</InvertedParagraph>
        <InvertedH2>{title}</InvertedH2>
      </div>
    </FlexBox>
  </ClickableBox>
);

const ManCollection = ({ onClick }) => (
  <CollectionCard
    onClick={onClick}
    image="https://assets-crm.schoeffel.de/public/images/assets/man.jpg"
    title={translate('man')}
  />
);

const WomanCollection = ({ onClick }) => (
  <CollectionCard
    onClick={onClick}
    title={translate('woman')}
    image="https://assets-crm.schoeffel.de/public/images/assets/woman.jpg"
  />
);

const TischOffensiveCard = ({ id, description, onClick }) => (
  <FlexBox
    flexDirection="column"
    marginRight="md"
    className={styles.outsideTischOffensiveCard}>
    <ClickableBox
      style={{
        border: '1px solid grey',
        backgroundImage: `url("https://assets-crm.schoeffel.de/public/images/sales_packages/${id}.jpg")`,
        backgroundPosition: 'top center',
        backgroundSize: 'cover',
      }}
      onClick={onClick}
      className={`tocard ${styles.tischOffensiveCard}`}
    />
    <Paragraph>{description}</Paragraph>
  </FlexBox>
);

export const LandingPage = withRouter(({ history }) => {
  const context = useContext(AppContext);

  const marketing = !!context.state.marketing;
  let marketingClass = '';
  if (marketing) {
    marketingClass = 'margin-10p';
  }
  const tischOffensives = getTischOffensivesForCurrentUser(context);

  // if (marketing) {
  //   tischOffensives = (tischOffensives || []).splice(0, 12);
  // }

  const onSelectCollection = (genre) => {
    navigateToProductListWithGenre({ history, genre });
  };

  const onSelectTischOffensive = (id) => {
    history.push(`/productList?tischOffensiveId=${id}`);
  };

  return (
    <>
      { marketing && (
<div style={{
  margin: '0 auto',
  position: 'absolute',
  zIndex: 100000000,
  left: 0,
  top: 0,
  right: 0,
  height: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

}}>
        <Logo />
</div>
      )}
    <Container>
      <FlexBox
        className={marketing && 'marketingLandingPage'}
        flex={1}
        flexDirection="column"
        alignItems="center"
        padding="xl">
        { !marketing && (
          <>
            <HugeTitle>{translate('welcome')}</HugeTitle>
            <TextOnlyUnderlinedButton
              text={translateCreateNewOrder('newOrder')}
              onClick={() => history.push(routes.orderCustomerSelection)}
            />
          </>
        )}
        {marketing && (
          <div className="huge">
            Digital Product Finder
          </div>
        )}
        <SpacingBox marginTop="sm" />
        <div className={marketingClass}>
        <FlexBox
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          style={{ maxWidth: 2000 }}
          flexDirection="row"
          marginTop="md"
          marginLeft="md"
          marginRight="md">
          {_.map(tischOffensives, (t) => (
            <TischOffensiveCard
              onClick={() => onSelectTischOffensive(t.id)}
              key={t.id}
              description={t.description}
              id={t.id}
            />
          ))}
        </FlexBox>
        </div>
        { !marketing && (
        <FlexBox marginTop="xl" alignItems="flex-end" flexDirection="row">
          <FlexBox flex={0.5}>
            <WomanCollection onClick={() => onSelectCollection(genres.woman)} />
          </FlexBox>
          <FlexBox marginLeft="lg" flex={0.5}>
            <ManCollection onClick={() => onSelectCollection(genres.men)} />
          </FlexBox>
        </FlexBox>
        )}
      </FlexBox>
    </Container>
    </>
  );
});

export default LandingPage;
